import moment from 'moment'
import { BACKEND_URL, get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'
import imageCompression from 'browser-image-compression'

export const toggleImageView = () => ({
    type: type.TOGGLE_IMAGE_VIEW,
})

export const findImageVersionRequest = () => ({
    type: type.FIND_IMAGE_VERSION_LIST_REQUEST,
    payload: {},
})

export const findImageVersionSuccess = imageVersionList => ({
    type: type.FIND_IMAGE_VERSION_LIST_SUCCESS,
    payload: {
        imageVersionList,
    },
})

export const findImageVersionError = error => ({
    type: type.FIND_IMAGE_VERSION_LIST_ERROR,
    payload: {
        error,
    },
})

export const findImageVersion = customerId => (dispatch, getState) => {
    dispatch(findImageVersionRequest())

    get('/api/customer/image-version-list?customerId=' + customerId)
        .then(imageVersionList => {
            dispatch(findImageVersionSuccess(imageVersionList))
        })
        .catch(error => {
            dispatch(findImageVersionError(error))
        })
}

export const findRecentImageVersion = customerId => (dispatch, getState) => {
    dispatch(findImageVersionRequest())

    get('/api/customer/image-version-list?customerId=' + customerId)
        .then(imageVersionList => {
            const filteredImageVersionList = filterImagesByAge(imageVersionList, 30)
            dispatch(findImageVersionSuccess(filteredImageVersionList))
        })
        .catch(error => {
            dispatch(findImageVersionError(error))
        })
}

function filterImagesByAge (imageVersionList, maxAge) {
    const filteredImageVersionList = {}
    Object.entries(imageVersionList).forEach(([key, value]) => {
        filteredImageVersionList[key] = value.filter(image =>
            moment().diff(image.lastModified, 'days') <= maxAge,
        )
        if (filteredImageVersionList[key].length === 0) {
            delete filteredImageVersionList[key]
        }
    })
    return filteredImageVersionList
}


export const uploadCustomerImageRequest = fileName => ({
    type: type.UPLOAD_CUSTOMER_IMAGE_REQUEST,
    payload: {
        fileName,
    },
})

export const uploadCustomerImageError = (error, fileName) => ({
    type: type.UPLOAD_CUSTOMER_IMAGE_ERROR,
    payload: {
        error,
        fileName,
    },
})

export const uploadCustomerImageSuccess = (imageVersionList, fileName) => ({
    type: type.UPLOAD_CUSTOMER_IMAGE_SUCCESS,
    payload: {
        imageVersionList,
        fileName,
    },
})

export const reuploadCustomerImageSuccess = (imageVersionList, imageType) => {
    const fileAdded = imageVersionList[imageType].filter((image) => {
        return image.isLatest
    })
    return {
        type: type.REUPLOAD_CUSTOMER_IMAGE_SUCCESS,
        payload: {
            fileAdded,
            imageType,
        },
    }
}

export const uploadCustomerImage = (fileList, fileName, customerId) => (
    dispatch,
    getState,
) => {
    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1632,
        useWebWorker: true,
    }
    imageCompression(fileList[0], options)
        .then(function (compressedFile) {
            fileList[0] = compressedFile
            dispatch(uploadCustomerImageRequest(fileName))

            const data = new FormData()
            data.append('file', compressedFile)

            fetch(
                BACKEND_URL +
                '/api/customer/image-upload-for-customer?customerId=' +
                customerId +
                '&fileName=' +
                fileName,
                {
                    method: 'post',
                    body: data,
                    headers: {
                        Accept: 'application/json',
                    },
                    credentials: 'include',
                },
            )
                .then(response => {
                    return response.json()
                })
                .then(imageVersionList => {
                    dispatch(uploadCustomerImageSuccess(imageVersionList, fileName))
                })
                .catch(error => {
                    dispatch(saveImageToLocalStorage(fileList, fileName, customerId))
                    dispatch(uploadCustomerImageError(error, fileName))
                })
        })
        .catch(function (error) {
            console.log(error.message)
        })
}

export const saveImageToLocalStorage = (fileList, fileName, customerId) => () => {
    const reader = new FileReader()
    reader.readAsDataURL(fileList[0])

    reader.addEventListener('load', function () {
        localStorage.setItem(customerId + '-' + fileName + '-img', this.result)
    })
}

export const retryUploadFromLocalStorage = (fileName, customerId) => (
    dispatch,
    getState,
) => {
    const fileList = [convertBase64ToFile(
        localStorage.getItem(customerId + '-' + fileName + '-img'),
    )]
    localStorage.removeItem(customerId + '-' + fileName + '-img')

    dispatch(reuploadCustomerImage(fileList, fileName, customerId))
}

const convertBase64ToFile = function (image) {
    const byteString = atob(image.split(',')[1])
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
    }
    return new File([ab], {
        type: 'image/jpeg',
    })
}

export const reuploadCustomerImage = (fileList, fileName, customerId) => (
    dispatch,
    getState,
) => {
    dispatch(uploadCustomerImageRequest(fileName))
    const data = new FormData()
    data.append('file', fileList[0])

    fetch(
        BACKEND_URL +
        '/api/customer/image-upload-for-customer?customerId=' +
        customerId +
        '&fileName=' +
        fileName,
        {
            method: 'post',
            body: data,
            headers: {
                Accept: 'application/json',
            },
            credentials: 'include',
        },
    )
        .then(response => {
            return response.json()
        })
        .then(imageVersionList => {
            dispatch(reuploadCustomerImageSuccess(imageVersionList, fileName))
        })
        .catch(error => {
            dispatch(saveImageToLocalStorage(fileList, fileName, customerId))
            dispatch(uploadCustomerImageError(error, fileName))
        })
}

export const rotateCustomerImageRequest = (
    fileName,
    versionId,
    targetDegree,
) => ({
    type: type.ROTATE_CUSTOMER_IMAGE_REQUEST,
    payload: {
        fileName,
        versionId,
        targetDegree,
    },
})

export const rotateCustomerImage = (fileName, versionId, degree) => (
    dispatch,
    getState,
) => {
    const state = getState()
    const imageVersion = selector.selectVersionImageVersion(
        state,
        fileName,
        versionId,
    )
    if (!imageVersion) {
        return null
    }
    let targetDegree =
        imageVersion.meta && imageVersion.meta.rotate
            ? imageVersion.meta.rotate
            : 0

    targetDegree = (targetDegree + degree) % 360
    if (targetDegree < 0) {
        targetDegree += 360
    }

    dispatch(rotateCustomerImageRequest(fileName, versionId, targetDegree))

    post('/api/customer/rotate-image-meta-data', {
        customerId: imageVersion.customerId,
        path: imageVersion.path,
        versionId: imageVersion.versionId,
        degree: targetDegree,
    })
}

export const setImageTypeMetaDataRequest = () => ({
    type: type.SET_IMAGE_TYPE_META_DATA_REQUEST,
})

export const setImageTypeMetaDataError = error => ({
    type: type.SET_IMAGE_TYPE_META_DATA_ERROR,
    payload: {
        error,
    },
})

export const setImageTypeMetaDataSuccess = (
    imageType,
    versionId,
    newImageType,
) => ({
    type: type.SET_IMAGE_TYPE_META_DATA_SUCCESS,
    payload: {
        imageType,
        versionId,
        newImageType,
    },
})

export const setImageTypeMetaData = (
    customerId,
    imageType,
    versionId,
    path,
    newImageType,
) => (dispatch, getState) => {
    dispatch(setImageTypeMetaDataRequest())

    post('/api/customer/set-image-type-meta-data', {
        customerId,
        path,
        versionId,
        imageType: newImageType,
    }).then(result => {
        dispatch(
            setImageTypeMetaDataSuccess(imageType, versionId, newImageType),
        )
    })
}

export const setSelectedImageType = (value) => ({
    type: type.SET_SELECTED_IMAGE_TYPE,
    payload: {
        selectedImageTypeName: value,
    },
})

export const setCurrentStep = (value) => ({
    type: type.SET_CURRENT_STEP,
    payload: {
        currentStep: value,
    },
})

export const setSlideIndex = (value) => ({
    type: type.SET_SLIDE_INDEX,
    payload: {
        slideIndex: value,
    },
})

export const deleteCustomerImageRequest = (fileId, versionId) => ({
    type: type.DELETE_CUSTOMER_IMAGE_REQUEST,
    payload: {
        fileId,
        versionId,
    },
})

export const deleteCustomerImageError = (error, fileId) => ({
    type: type.DELETE_CUSTOMER_IMAGE_ERROR,
    payload: {
        error,
        fileId,
    },
})

export const deleteCustomerImageSuccess = (imageType, fileId, versionId) => ({
    type: type.DELETE_CUSTOMER_IMAGE_SUCCESS,
    payload: {
        imageType,
        fileId,
        versionId,
    },
})

export const deleteCustomerImage = (fileId, imageType, versionId) => (
    dispatch,
    getState,
) => {
    dispatch(deleteCustomerImageRequest(fileId, versionId))
    fetch(
        BACKEND_URL +
        '/api/customer/delete-customer-image?versionId=' + versionId + '&fileId=' + fileId,
        {
            method: 'post',
            headers: {
                Accept: 'application/json',
            },
            credentials: 'include',
        },
    )
        .then(response => {
            return response.json()
        })
        .then(imageVersionList => {
            dispatch(deleteCustomerImageSuccess(imageVersionList, fileId, versionId))
        })
        .catch(error => {
            dispatch(deleteCustomerImageError(error, fileId, versionId))
        })

    dispatch(deleteCustomerImageSuccess(imageType, fileId, versionId))
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/image/action.js